import axios from 'axios';
import moment from "moment";
import React, {useEffect, useState} from 'react';
import { Card, Col, Form, ListGroup, ListGroupItem, ProgressBar, Row } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { queryCache, useMutation } from 'react-query';
import Alert from 'react-s-alert';
import ReactS3Uploader from "react-s3-uploader";

const PresentationUpload = ({ intl, presentations, token }) => {
  console.log("presentations",presentations);
  
  return <div>
    {
      presentations.length === 0 && <i>No videos available yet</i>
    }
    {
      presentations.map(presentation => (<div className="m-t-30">
        <PresentationUploadSingle
          key={presentation._id}
          intl={intl}
          presentationData={presentation}
          token={token} />
      </div>))
    }
  </div>
}

const PresentationUploadSingle = ({ presentationData, intl, token }) => {
  const [videoModal, setVideoModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [presentation, setPresentation] = useState(presentationData);

  const [updatePresentationMutation, { isLoading: updatePresentationLoading }] = useMutation(({ _id, update }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker-data/update-presentation/${_id}`,
    method: 'PATCH',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    data: update
  }).then(response => response.data), {
    onSuccess: (updatedPresentation) => {
      queryCache.setQueryData(
        ['speaker-presentations', updatedPresentation.event_id, updatedPresentation.speaker_id],
        (presentations) => {
          console.log("PPT_UPLOAD  ",presentations,updatedPresentation);
          //if(presentations !==undefined){
             setPresentation(updatedPresentation);
            // presentations[presentations.indexOf(updatedPresentation)] = updatedPresentation;
             //presentations.map(presentation => presentation._id === updatedPresentation._id ? { ...presentation, ...updatedPresentation } : presentation)
           // }
           window.location.reload();
        }
      )

      // Alert.closeAll();
      Alert.success(intl.formatMessage({ id: "presentation.update-success" }));
    },
    onError: (err) => {
      console.log("PPT_UPLOAD onError ",err);
      Alert.closeAll();
      Alert.error(intl.formatMessage({ id: "error.server-error" }))
    }
  })

  console.log('presentation',presentation);


  return <div className="m-t-30">
    <Card className="shadow-card">
      <Card.Header>Presentation and settings for <b>{presentation.name}</b>,
        {` ${moment(presentation.date).format(
          "DD/MM/YYYY"
        )} ${presentation.time}`}</Card.Header>jjjj
      <Card.Body>
        <Form.Group>
          <Form.Check
            type="checkbox"
            id={`${presentation._id}_public`}
            checked={presentation.public}
            disabled={updatePresentationLoading}
            onChange={(e) => updatePresentationMutation({
              _id: presentation._id,
              update: {
                public: e.target.checked
              }
            })}
            label={intl.formatMessage({
              id: "label.agree-broadcast",
            })}
          />
        </Form.Group>
        <Form.Group>
          <Form.Check
            type="checkbox"
            id={`${presentation._id}_pdfConvert`}
            checked={presentation.pdfConvert}
            disabled={updatePresentationLoading}
            onChange={(e) => updatePresentationMutation({
              _id: presentation._id,
              update: {
                pdfConvert: e.target.checked
              }
            })}
            label={intl.formatMessage({
              id: "label.agree-pdfConvert",
            })}
          />
        </Form.Group>
        <ManagePpts
          presentation={presentation}
          intl={intl}
          token={token}
          onFileUpload={(file) => updatePresentationMutation({
            _id: presentation._id,
            update: {
              ppt: file
            }
          })}
        />
      </Card.Body>
    </Card>
  </div>
}

const ManagePpts = ({ presentation, intl, token, onFileUpload }) => {
  // return <pre>{JSON.stringify(presentation, null, 2)}</pre>
  const [progress, setProgress] = useState(0);
  return (
    <Card>
      <Card.Header>
        {presentation.ppt.length}{" "}
        <FormattedMessage id="heading.files-uploaded-for" /> "
        <b>{presentation.name}</b>"
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <h4>
              <ReactS3Uploader
                placeholder="Presentation"
                className="inputfile"
                id={`ppt-for-${presentation._id}-${presentation.ppt.length}`}
                style={{
                  display: "none",
                }}
                name={`ppt-for-${presentation._id}-${presentation.ppt.length}`}
                signingUrl="/speaker-data/s3"
                signingUrlMethod="GET" // default "GET"
                accept=".ppt,.pptx,.pps,.pdf"
                preprocess={(file, next) => {
                  Alert.warning(
                    intl.formatMessage({
                      id: "button.uploadingPresentation",
                    })
                  );
                  next(file);
                }}
                onProgress={(progress) => {
                  setProgress(progress);
                  Alert.warning(`${progress}% uploaded`);
                }}
                onError={() => {
                  Alert.error(
                    intl.formatMessage({
                      id: "error.file-upload",
                    })
                  );
                }}
                onFinish={(url) => {
                  onFileUpload(url.publicUrl);
                  Alert.success(
                    intl.formatMessage({
                      id: "input.presentation.presentationUploaded",
                    })
                  );
                }} // url.publicUrl
                signingUrlHeaders={{
                  Authorization: `Bearer ${token}`
                }}
                uploadRequestHeaders={{
                  "x-amz-acl": "public-read",
                }}
                contentDisposition="auto"
                server={process.env.REACT_APP_API_HOST}
              />
              <label
                htmlFor={`ppt-for-${presentation._id}-${presentation.ppt.length}`}
                className="btn btn-primary"
              >
                <img
                  src="/images/icon-upload-white.png"
                  alt="Upload Presentation"
                  height="24"
                />
                <FormattedMessage id="input.presentation.presentationUpload" />
              </label>
            </h4>
          </Col>
          <Col md={6}>
            <br />
            {progress > 0 && (
              <ProgressBar
                style={{
                  display: "inline-block",
                  width: "200px",
                }}
                now={progress}
                label={`${progress}%`}
              />
            )}
          </Col>
        </Row>

        <ListGroup>
          {presentation.ppt.map((f) => {
            return (
              <ListGroupItem key={f.file}>
                <FormattedMessage id="label.file-uploaded-on" />{" "}
                {moment(f.date).format("DD/MM/YYYY HH:mm")}{" "}
                <a
                  className="btn btn-sm btn-primary"
                  href={`${process.env.REACT_APP_ASSET_URL}${f.file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/icon-download.png"
                    alt="Download Presentation"
                    height="24"
                  />
                  <FormattedMessage id="link.download" />
                </a>
                {/* {props.deleteFile ? (
                  <Button
                    size="small"
                    variant="danger"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      props.deleteFile(
                        f.file,
                        `File uploaded on ${moment(f.date).format(
                          "DD/MM/YYYY h:mm"
                        )}`
                      );
                    }}
                  >
                    <FormattedMessage id="button.presentation-delete-file" />
                  </Button>
                ) : (
                  ""
                )} */}
              </ListGroupItem>
            );
          })}
        </ListGroup>
      </Card.Body>
    </Card>
  );
}

export default injectIntl(PresentationUpload);
